import { render, staticRenderFns } from "./MarketSettingTask.vue?vue&type=template&id=edcadc52"
import script from "./MarketSettingTask.vue?vue&type=script&lang=js"
export * from "./MarketSettingTask.vue?vue&type=script&lang=js"
import style0 from "./MarketSettingTask.vue?vue&type=style&index=0&id=edcadc52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports